import { Policy, RuleModel } from '../../../../types';
import GeneralDialog from '../../../shared/general-dialog';
import RulesEngineRunLogsGrid from './rules-engine-run-logs-grid';

interface RulesEngineLogsDialogProps {
  open: boolean;
  handleClose: () => void;
  selectedRule: RuleModel;
  policies: Policy[];
  rules: RuleModel[];
}

export default function RulesEngineLogsDialog({
  open,
  handleClose,
  selectedRule,
  policies,
  rules,
}: RulesEngineLogsDialogProps) {
  return (
    <GeneralDialog
      maxWidth="md"
      open={open}
      handleClose={handleClose}
      title={`Rule Logs: ${selectedRule.basicInfo.ruleName}`}
      dialogContent={
        <RulesEngineRunLogsGrid
          ruleId={selectedRule.id}
          policies={policies}
          rules={rules}
        />
      }
    />
  );
}
